var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransportActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#6A8860"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#6A8860"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7406 27.4401L14.0126 26.0841C12.2246 24.4041 11.2526 22.1481 11.2526 19.7241C11.2526 14.9001 15.1766 10.9761 20.0006 10.9761C24.8246 10.9761 28.7486 14.9001 28.7486 19.7241C28.7486 22.1121 27.7886 24.3441 26.0486 26.0121L27.3446 27.3561C29.4566 25.3281 30.6206 22.6161 30.6206 19.7241C30.6206 13.8801 25.8566 9.11609 20.0126 9.11609C14.1686 9.11609 9.39258 13.8801 9.39258 19.7241C9.39258 22.6641 10.5806 25.4121 12.7406 27.4401Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3561 25.6641L11.0361 30.8841H13.4601L14.4081 29.7321H25.5921L26.5401 30.8841H28.9641L24.6441 25.6641C25.0761 25.5681 25.4721 25.3281 25.7721 24.9921C26.2041 24.5001 26.3961 23.8401 26.3001 23.1801L25.4001 16.5681C25.1601 14.8401 23.7321 13.5441 22.0761 13.5441H17.9241C16.2681 13.5441 14.8401 14.8401 14.6001 16.5681L13.7001 23.1801C13.6161 23.8401 13.8081 24.5001 14.2281 24.9921C14.5281 25.3281 14.9241 25.5681 15.3561 25.6641ZM15.9441 27.8721L17.7201 25.7121H22.2561L24.0321 27.8721H15.9441ZM20.9361 15.4041H22.0761C22.8081 15.4041 23.4441 16.0161 23.5521 16.8201L23.7321 18.1761H20.9361V15.4041ZM16.4481 16.8201C16.5561 16.0161 17.1921 15.4041 17.9241 15.4041H19.0641V18.1641H16.2681L16.4481 16.8201ZM15.5481 23.4321L15.6561 22.6521H17.6601V21.0321H15.8721L16.0161 20.0241H23.9961L24.1401 21.0321H22.3521V22.6521H24.3561L24.4641 23.4321C24.4881 23.6121 24.4041 23.7201 24.3681 23.7561C24.3321 23.7921 24.2721 23.8521 24.1881 23.8521H15.8241C15.7401 23.8521 15.6801 23.8041 15.6441 23.7561C15.6081 23.7201 15.5241 23.6121 15.5481 23.4321Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportActive);
export default __webpack_public_path__ + "static/media/transportActive.f9e07cd138cfbacaf87726fd2a3ffd86.svg";
export { ForwardRef as ReactComponent };